import { useGetDashboardGroupSummary } from 'hooks/queries/dashboard';
import useGetSearchParams from 'hooks/useGetSearchParams';
import CoreLoading from 'shared/CoreLoading';
import { ReportSectionCard, ReportTopHeader } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';

const mockData = {
	memberStatus: {
		totalMembers: 100,
		selectedMembers: 80,
		contractedMembers: 50,
	},
	contentStatus: {
		reels: {
			scheduledContent: 10,
			uploadedContent: 8,
		},
		styleClips: {
			scheduledContent: 15,
			uploadedContent: 12,
		},
	},
	missionStatus: [
		{
			missionNumber: 1,
			productPurchase: {
				completed: 1,
			},
			contentShooting: {
				completed: 1,
			},
			reelsUpload: {
				completed: 5,
				notStarted: 5,
			},
			styleClipUpload: {
				completed: 7,
				notStarted: 3,
			},
		},
		{
			missionNumber: 2,
			productPurchase: {
				completed: 0,
			},
			contentShooting: {
				completed: 1,
			},
			reelsUpload: {
				completed: 3,
				notStarted: 7,
			},
			styleClipUpload: {
				completed: 4,
				notStarted: 6,
			},
		},
		{
			missionNumber: 3,
			productPurchase: {
				completed: 0,
			},
			contentShooting: {
				completed: 0,
			},
			reelsUpload: {
				completed: 0,
				notStarted: 10,
			},
			styleClipUpload: {
				completed: 0,
				notStarted: 12,
			},
		},
	],
};

const ProgressStatusCard = () => {
	const [groupId] = useGetSearchParams(['groupId']);

	const { data: groupSummary, isLoading } = useGetDashboardGroupSummary(groupId);

	if (isLoading || !groupSummary) {
		return (
			<Grid flex="between" _gap="16px" _height="100%">
				<ReportSectionCard>
					<ReportTopHeader>인원 현황</ReportTopHeader>
					<Grid flex="center">
						<CoreLoading color_type="gray" />
					</Grid>
				</ReportSectionCard>

				<ReportSectionCard>
					<ReportTopHeader>콘텐츠 현황</ReportTopHeader>
					<Grid flex="center">
						<CoreLoading color_type="gray" />
					</Grid>
				</ReportSectionCard>
			</Grid>
		);
	}

	return (
		<Grid flex="between" _gap="16px">
			{/* 인원 현황 */}
			<ReportSectionCard>
				<ReportTopHeader>인원 현황</ReportTopHeader>
				<Grid flex="start">
					<Grid flex="start" align_items="start" direction="column">
						<Text typo="h3">{groupSummary.memberStatus.totalMembers}</Text>
						<Text typo="span">총 모집 인원</Text>
					</Grid>
					<Grid flex="start" align_items="start" direction="column">
						<Text typo="h3">{groupSummary.memberStatus.selectedMembers}</Text>
						<Text typo="span">선정된 인원</Text>
					</Grid>
					<Grid flex="start" align_items="start" direction="column">
						<Text typo="h3">{groupSummary.memberStatus.contractedMembers}</Text>
						<Text typo="span">계약 완료</Text>
					</Grid>
				</Grid>
			</ReportSectionCard>

			{/* 콘텐츠 현황 */}
			<ReportSectionCard>
				<ReportTopHeader>콘텐츠 현황</ReportTopHeader>
				<Grid flex="start">
					<Grid flex="start" align_items="start" direction="column">
						<Text typo="h3">
							{groupSummary.contentStatus.reels.uploadedContent +
								groupSummary.contentStatus.styleClips.uploadedContent}
							/
							{groupSummary.contentStatus.reels.scheduledContent +
								groupSummary.contentStatus.styleClips.scheduledContent}
						</Text>
						<Text typo="span">총 업로드 콘텐츠</Text>
					</Grid>
					<Grid flex="start" align_items="start" direction="column">
						<Text typo="h3">
							{groupSummary.contentStatus.reels.uploadedContent}/
							{groupSummary.contentStatus.reels.scheduledContent}
						</Text>
						<Text typo="span">릴스</Text>
					</Grid>
					<Grid flex="start" align_items="start" direction="column">
						<Text typo="h3">
							{groupSummary.contentStatus.styleClips.uploadedContent}/
							{groupSummary.contentStatus.styleClips.scheduledContent}
						</Text>
						<Text typo="span">스타일클립</Text>
					</Grid>
				</Grid>
			</ReportSectionCard>
		</Grid>
	);
};

const { Grid, Text } = style;
export default ProgressStatusCard;
